import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import SignaturePad from "react-signature-canvas";
import {
  canEmployeeSignPaf,
  formatSignedDate,
  isEmployeePafSigned,
} from "pages/AppraisalManagment/utils/myPafHelpers";
import "../../../Appraisal/AppraisalProgressForm/component/SignOffTab/SignOffTab.css";

const MyPafEmployeeSignPanel = ({ record, onConfirm, onCancel, isSubmitting = false }) => {
  const sigPadRef = useRef(null);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [signatureImage, setSignatureImage] = useState("");
  const [signSuccessMessage, setSignSuccessMessage] = useState("");

  const alreadySigned = isEmployeePafSigned(record);
  const canSign = canEmployeeSignPaf(record);
  const signedDateLabel = formatSignedDate(record);

  const handleConfirm = async () => {
    if (alreadySigned || isSubmitting) return;

    if (!isConfirmed) {
      alert("Please check the confirmation box before signing.");
      return;
    }

    let finalSignature = signatureImage;
    if (sigPadRef.current && typeof sigPadRef.current.isEmpty === "function") {
      if (!sigPadRef.current.isEmpty()) {
        finalSignature = sigPadRef.current.toDataURL("image/png");
      }
    }

    try {
      await onConfirm({ employee_signature: finalSignature || null });
      setSignSuccessMessage("Your PAF has been confirmed and signed successfully.");
    } catch (error) {
      console.error("Employee sign failed:", error);
    }
  };

  if (!alreadySigned && !canSign) {
    return (
      <div className="border rounded-3 p-3 bg-light">
        <p className="mb-2 font-13 font-weight-s-bold heading-color">Employee Confirmation</p>
        <p className="mb-0 font-13 text-muted">
          Signing is not available yet. Your supervisor must complete scoring before you can
          confirm and sign this PAF.
        </p>
      </div>
    );
  }

  if (alreadySigned) {
    return (
      <div className="border rounded-3 p-3 bg-light">
        <p className="mb-2 font-13 font-weight-s-bold heading-color">Employee Confirmation</p>
        <p className="mb-1 text-success font-13">
          You have already signed this PAF{signedDateLabel ? ` on ${signedDateLabel}` : ""}.
        </p>
        {record?.employee_signature_image || record?.employee_signature ? (
          <img
            src={record.employee_signature_image || record.employee_signature}
            alt="Employee Signature"
            style={{ maxWidth: 240, maxHeight: 100, border: "1px solid #dfe4e2", borderRadius: 8 }}
          />
        ) : null}
      </div>
    );
  }

  return (
    <div className="border rounded-3 p-3">
      <p className="mb-3 font-13 font-weight-s-bold heading-color">Employee Confirmation &amp; Signature</p>

      {signSuccessMessage ? (
        <div className="alert alert-success py-2 font-13">{signSuccessMessage}</div>
      ) : null}

      <Form.Check
        type="checkbox"
        id="my-paf-confirm-checkbox"
        className="mb-3"
        label="I confirm and accept my scoring."
        checked={isConfirmed}
        onChange={(e) => setIsConfirmed(e.target.checked)}
        disabled={isSubmitting || Boolean(signSuccessMessage)}
      />

      <div className="signature-module-card p-3 mb-3">
        <p className="font-12 text-muted mb-2">
          Optional: draw your signature below, or use Confirm &amp; Sign without a drawing.
        </p>
        <div className="signature-canvas-shell">
          <SignaturePad
            ref={sigPadRef}
            canvasProps={{
              width: 500,
              height: 140,
              className: "signature-canvas",
            }}
            onEnd={() => {
              if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
                setSignatureImage(sigPadRef.current.toDataURL("image/png"));
              }
            }}
          />
        </div>
        <button
          type="button"
          className="clear-btn mt-2"
          onClick={() => {
            sigPadRef.current?.clear();
            setSignatureImage("");
          }}
          disabled={isSubmitting || Boolean(signSuccessMessage)}
        >
          Clear Signature
        </button>
      </div>

      <div>
        <button
          type="button"
          className="n-u-btn"
          onClick={handleConfirm}
          disabled={isSubmitting || !isConfirmed || Boolean(signSuccessMessage)}
        >
          {isSubmitting ? "Signing…" : "Confirm & Sign"}
        </button>
        <button
          type="button"
          className="c-b-btn ms-2"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default MyPafEmployeeSignPanel;
